import type { Id } from '@goaltree/backend/convex/_generated/dataModel'
import { createFileRoute, redirect } from '@tanstack/react-router'

import { useEventSheet } from '@/store/event-sheet.store'

// Reminder pushes link to /upcoming?event=<id>.
export const Route = createFileRoute('/_authenticated/upcoming')({
  validateSearch: (search): { event?: string } => ({
    event: typeof search.event === 'string' ? search.event : undefined,
  }),
  beforeLoad: ({ search }) => {
    if (search.event) useEventSheet.getState().open(search.event as Id<'nodes'>)
    throw redirect({ to: '/everyday', search: { tab: 'events' }, replace: true })
  },
})
